module.exports = __webpack_public_path__ + "static/media/prodigypage.c9ed5382.jpg";